'use client';

import { ChevronDown, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/forms/button';

interface ShowMoreButtonProps {
  loading: boolean;
  remaining: number;
  noun: string;
  onClick: () => void;
  size?: 'sm' | 'default';
}

/**
 * Single "Show N more <noun>" affordance used at the section level and
 * inside company anchors. Loading state is intrinsic — the button shows
 * a spinner and disables itself while a fetch is in flight.
 */
export function ShowMoreButton({
  loading,
  remaining,
  noun,
  onClick,
  size = 'sm',
}: ShowMoreButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      onClick={onClick}
      disabled={loading || remaining <= 0}
    >
      {loading ? (
        <>
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          Loading {noun}…
        </>
      ) : (
        <>
          Show {remaining} more {noun}
          <ChevronDown className="h-3.5 w-3.5" />
        </>
      )}
    </Button>
  );
}
